import React, { useEffect, useRef, useState } from 'react';

export default function About() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="about" className="about-section" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className={`about-content ${isVisible ? 'visible' : ''}`}>
          <div className="about-image">
            <img 
              src={`${process.env.PUBLIC_URL}/images/selva.jpg`} 
              alt="Selvarajan - Full Stack Developer"
            />
          </div>
          <div className="about-text">
            <h3>Full Stack Developer</h3>
            <p>
              I'm Selvarajan, a passionate Full Stack Developer with expertise in building modern,
              scalable web applications. With a strong foundation in both frontend and backend technologies,
              I bring ideas to life through clean, efficient code.
            </p>
            <p>
              My journey in software development has equipped me with diverse skills ranging from
              creating responsive user interfaces with React to developing robust backend systems
              with Django and Flask. I thrive on solving complex problems and continuously learning
              new technologies.
            </p>
            <p>
              I have hands-on experience in IT solutions, system diagnostics, and network troubleshooting,
              which gives me a comprehensive understanding of the entire technology stack. My passion
              lies in creating applications that not only meet technical requirements but also deliver
              exceptional user experiences.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
